export enum ErrorCode {
  USER_ALREADY_SUBSCRIBED_ERROR = '403157',
}
